import { supabase } from '../supabaseClient';

export const getParticipants = async () => {
  try {
    const { data, error } = await supabase
      .from('participants')
      .select('*')
      .order('nom', { ascending: true });

    if (error) throw error;
    return { data, error: null };
  } catch (error) {
    console.error('Erreur lors de la récupération des participants:', error);
    return { data: null, error };
  }
};

export const createParticipant = async (nom: string) => {
  try {
    // Récupérer l'utilisateur connecté
    const { data: { user }, error: authError } = await supabase.auth.getUser();
    
    if (authError || !user) {
      throw new Error('Utilisateur non connecté');
    }

    const { data, error } = await supabase
      .from('participants')
      .insert([{ nom, user_id: user.id }])
      .select()
      .single();

    if (error) throw error;
    return { data, error: null };
  } catch (error) {
    console.error('Erreur lors de la création du participant:', error);
    return { data: null, error };
  }
};

export const updateParticipant = async (id: string, nom: string) => {
  try {
    const { data, error } = await supabase
      .from('participants')
      .update({ nom })
      .eq('id', id)
      .select()
      .single();

    if (error) throw error;
    return { data, error: null };
  } catch (error) {
    console.error('Erreur lors de la mise à jour du participant:', error);
    return { data: null, error };
  }
};

export const deleteParticipant = async (id: string) => {
  try {
    const { error } = await supabase
      .from('participants')
      .delete()
      .eq('id', id);

    if (error) throw error;
    return { error: null };
  } catch (error) {
    console.error('Erreur lors de la suppression du participant:', error);
    return { error };
  }
}; 